import { render } from "./transfer_history.vue?vue&type=template&id=f1b66fce&scoped=true"
import script from "./transfer_history.vue?vue&type=script&lang=js"
export * from "./transfer_history.vue?vue&type=script&lang=js"

import "./transfer_history.vue?vue&type=style&index=0&id=f1b66fce&lang=scss&scoped=true"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1b66fce"]])

export default __exports__